/** 사이드바·모바일 메뉴 — 챗봇 공지사항 (클릭 시 /notices) */
export const NOTICE_MENU_LABELS = [
  '챗봇 공지사항',
  'Chatbot Notices',
  'チャットボットお知らせ',
  '聊天机器人公告',
] as const;

export function isNoticeMenuLabel(label: string): boolean {
  return (NOTICE_MENU_LABELS as readonly string[]).includes(label);
}
